import { SORT_KEYS, TableFilterObjectBody } from '@app-store'
import { Pagination } from '@ui-kit'
import { useEffect, useRef } from 'react'

const PaginationWithFilter: React.FC<{
  getAndUpdateData: (
    currentPage: number,
    rowsPerPage: number
  ) => Promise<{
    totalPages: number | undefined
    totalElements?: number
    numberOfElements?: number
    pageable: { pageNumber: number | undefined }
  }>
  filter: TableFilterObjectBody
  refetch: string
  sortDirection:
    | {
        keyName: string
        direction: SORT_KEYS
        isAsc: SORT_KEYS
        key: string
      }
    | undefined
  hidePagination?: boolean
  hasViewDropdown?: boolean
  paginationData: {
    currentPage: number
    rowsPerPage: number
    totalPages: number
    totalElements: number
    numberOfElements: number
  }
  setPaginationData: React.Dispatch<
    React.SetStateAction<{
      currentPage: number
      rowsPerPage: number
      totalPages: number
      totalElements: number
      numberOfElements: number
    }>
  >
}> = ({
  getAndUpdateData,
  filter,
  refetch,
  sortDirection,
  hidePagination,
  hasViewDropdown,
  paginationData,
  setPaginationData,
}) => {
  const firstRender = useRef(true)
  const firstFilterChange = useRef(true)
  const firstSortChange = useRef(true)

  const onPageChange = async (page: number, rowsPerPage: number) => {
    if (paginationData.rowsPerPage !== rowsPerPage) page = 1
    const uiPage = Math.max(1, page)
    const response = await getAndUpdateData(uiPage - 1, rowsPerPage)
    setPaginationData({
      currentPage:
        response.pageable?.pageNumber !== undefined &&
        response.pageable?.pageNumber >= 0
          ? response.pageable?.pageNumber + 1
          : uiPage,
      rowsPerPage: rowsPerPage,

      totalPages: response.totalPages ?? 1,
      totalElements: response.totalElements ?? 1,
      numberOfElements: response.numberOfElements ?? 1,
    })
  }

  useEffect(() => {
    //NOTE: Handling fetch logic on filter change using handleFilterChange function when ViewsDropdown is present
    if (hasViewDropdown) return
    if (!firstFilterChange.current) onPageChange(1, paginationData.rowsPerPage)
    firstFilterChange.current = false
  }, [filter])

  useEffect(() => {
    if (!firstRender.current)
      onPageChange(paginationData.currentPage, paginationData.rowsPerPage)
    firstRender.current = false
  }, [refetch])

  useEffect(() => {
    if (!firstSortChange.current)
      onPageChange(paginationData.currentPage, paginationData.rowsPerPage)
    firstSortChange.current = false
  }, [sortDirection])

  return (
    <Pagination
      currentPage={paginationData.currentPage}
      totalPages={paginationData.totalPages}
      onPageChange={onPageChange}
      rowsPer={25}
      hidePagination={hidePagination}
      totalElements={paginationData.totalElements}
      numberOfElements={paginationData.numberOfElements}
    />
  )
}

export default PaginationWithFilter
